<ng-template #content let-modal>
  <div class="modal-header border-bottom-0">
    <h5 class="modal-title">{{ 'INVITE.NEWINVITE' | translate }}</h5>
    <div id="closeModal" *ngIf="showAsModal">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click'); jobtypeSelected = null">
        <span aria-hidden="true">&times;</span>&nbsp;
        <span>{{ 'COMMON.CLOSE' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="modal-header rounded-0 justify-content-start" *ngIf="selectedCandidates$ | async as candidates">
    <span class="modal-title">{{ 'COMMON.CANDIDATE' | translate }}</span>
    <ng-container *ngIf="candidates.length === 1">
      <span class="ml-5">{{ (candidates[0].name || '') + ' ' + (candidates[0].surname1 || '') + ' ' + (candidates[0].surname2 || '') | titlecase }}</span>
      <span class="ml-5">{{ candidates[0].email | lowercase }}</span>
    </ng-container>
    <ng-container *ngIf="candidates.length > 1">
      <span class="ml-5">{{ candidates.length }} {{ 'INVITE.CANDIDATESSELECTED' | translate }}</span>
    </ng-container>
  </div>

  <div class="modal-body">
    <div class="container my-3" *ngIf="step === 'tests'">
      <div class="form-group">
        <div class="row">
          <div class="col-lg-4">
            <label for="process">{{ 'COMMON.PROCESS' | translate }}</label>
            <select class="form-control" id="process" [(ngModel)]="process" (change)="setJobtypeFromProcess()">
              <option [ngValue]="null" hidden>{{ 'INVITE.SELECTPROCESS' | translate }}</option>
              <option *ngFor="let process of (processes$ | async)?.data" [ngValue]="process">{{ process.name }}</option>
            </select>

            <div class="createProcessButton" (click)="createProcess()">
              <h5><i class="fa fa-plus-circle"></i> {{ 'PROCESSES.CREATEPROCESS' | translate }}</h5>
            </div>
          </div>

          <div *ngIf="(HCC.includes(officeId))" class="col-lg-4">
            <label for="projectId">{{ 'COMMON.PROJECT' | translate }}</label>
            <select class="form-control" id="projectId" (change)="setProject()" [(ngModel)]="projectId">
              <option [value]="null">{{ 'INVITE.PROJECTNOTSELECTED' | translate }}</option>
              <ng-container *ngFor="let parentProject of projects">
                <option *ngFor="let project of parentProject.children" [value]="[parentProject.id, project.id]">
                  {{ project.name + (project.description ?  ' - ' + project.description : '') }}
                </option>
              </ng-container>
            </select>

            <button type="button" class="buttonLikeLink" (click)="showModalContact('contactContent')"
              [ngClass]="{'buttonLikeLink-disable':  !projectSelected}" [disabled]="!projectSelected">
              <h5><i class="fa fa-info-circle"></i> {{ 'COMMON.CONTACT' | translate }}</h5>
            </button>
          </div>

        </div>
      </div>


      <hr class="my-4">
      <div class="form-group">
        <div class="row">
          <div class="col-lg-4">
            <label for="language">{{ 'INVITE.TESTLANGUAGE' | translate }}</label>
            <div class="form-group form-row">
              <div class="col-12">
                <select class="form-control" id="language" [(ngModel)]="language" [disabled]="disabledLanguageSelector()" (change)="showLanguageRequired()">
                  <option [ngValue]="null" hidden>{{ 'INVITE.SELECTLANGUAGE' | translate }}</option>
                  <option [value]="currentConsultant.client.id != 5 ? currentConsultant.client.id : 1 ">{{ 'LANGUAGE.SPANISH' | translate }}</option>
                  <option value="7">{{ 'LANGUAGE.ENGLISH' | translate }}</option>
                  <option value="5">{{ 'LANGUAGE.PORTUGUESE' | translate }}</option>
                </select>
                <div class="invalid-feedback d-block" *ngIf="languageRequired">{{ 'VALIDATIONS.REQUIRED' | translate }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="my-4">

      <div class="row" id="tests">
        <div class="col-md-4">
          <h5>{{ 'INVITE.COMPETENCESTEST' | translate }}</h5>
          <h5 (click)="step = 'skill'"><i class="fa fa-plus-circle"></i> {{ 'INVITE.ADDCOMPETENCESTEST' | translate }}</h5>
          <ngb-alert type="info" *ngFor="let skillTest of skillTests; let i = index" (closed)="skillTests.splice(i, 1);">
            {{ skillTest | titlecase }} {{ languages[language] | translate }}
          </ngb-alert>
        </div>
        <!-- ocultamos test de conocimientos para MX y PT -->
        <div class="col-md-4" *ngIf="![3,5].includes(currentConsultant.client.id)">
          <h5>{{ 'INVITE.KNOWLEDGETEST' | translate }}</h5>
          <h5 (click)="step = 'knowledge'"><i class="fa fa-plus-circle"></i> {{ 'INVITE.ADDKNOWLEDGETEST' | translate }}</h5>
          <ngb-alert type="info" *ngFor="let knowledgeTest of knowledgeTests; let i = index" (closed)="knowledgeTests.splice(i, 1);">
            {{ knowledgeTest.name }}
          </ngb-alert>
        </div>
      </div>
    </div>

    <div class="container my-3" *ngIf="step === 'skill'">
      <h4 class="mb-3 font-weight-bold">{{ 'INVITE.COMPETENCESTEST' | translate }}</h4>
      <div class="row">
        <div class="col-5">
          <label for="jobtype">{{ 'COMMON.JOBTYPE' | translate }}</label>
          <div class="form-group form-row">
            <div class="col-12">
              <select class="form-control" id="jobtype" [(ngModel)]="jobtype" [disabled]="!!process.jobtypeId"
                (change)="jobtypeSelected = jobtype; notifyAdnReport = true; notifyMindsetDigitalReport = false;">
                <option [ngValue]="null" hidden>{{ 'INVITE.SELECTJOBTYPE' | translate }}</option>
                <option *ngFor="let jobtype of jobtypes$ | async" [ngValue]="jobtype">
                  {{ jobtype.name | titlecase }}
                </option>
              </select>
              <div class="invalid-feedback d-block" *ngIf="checkErrors && !this.jobtype">{{ 'VALIDATIONS.REQUIRED' | translate }}</div>
            </div>
          </div>

          <ng-container *ngIf="getbusinessId().includes(2) && this.bussinessArea.includes(2); else elseTemplate">
            <label class="mt-2">{{'CONSULTANT.SENDREPORTAUTOMATICALLY' | translate}}:</label>
            <div class="row">
              <div class="col-12 pl-5">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" id="notifyAdnReport" [(ngModel)]="notifyAdnReport">
                  <label class="custom-control-label ml-2" for="notifyAdnReport">{{ 'COMMON.COMPETENCES' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 pl-5">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" id="notifyMindsetDigitalReport" [(ngModel)]="notifyMindsetDigitalReport">
                  <label class="custom-control-label ml-2" for="notifyMindsetDigitalReport">Mindset Digital</label>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #elseTemplate>
            <div class="row mt-2">
              <div class="col-12">
                <div class="custom-control custom-checkbox">
                  <input class="custom-control-input" type="checkbox" id="notifyAdnReport" [(ngModel)]="notifyAdnReport">
                  <label class="custom-control-label ml-2" for="notifyAdnReport">{{'CONSULTANT.SENDREPORTAUTOMATICALLY' | translate}}</label>
                </div>
              </div>
            </div>
          </ng-template>
        </div>

        <div class="offset-1 col-6" *ngIf="jobtypeSelected">
          <label for="skills">{{ 'INVITE.RELATEDCOMPETENCES' | translate }}: {{ jobtypeSelected.name | titlecase }}</label>
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>{{ 'COMMON.AREA' | translate }}</th>
                <th>{{ 'COMMON.COMPETENCE' | translate }}</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let questionGroup of jobtypeSelected.questionGroups; index as i">
                <ng-container *ngIf="currentConsultant.office.businessAreaIds.includes(questionGroup.testModelId)">
                  <td>{{ 'ADNREPORT.SKILLS.TYPES.' + questionGroup.type.toUpperCase() | translate }}</td>
                  <td>{{ ('ADNREPORT.SKILLS.' + questionGroup.abbreviation + '.NAME') | translate }}</td>
                </ng-container>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="container my-3" *ngIf="step === 'knowledge'">
      <h4 class="mb-4">{{ 'INVITE.KNOWLEDGETEST' | translate }}</h4>
      <div class="row">
        <div class="col-5">
          <h6>{{ 'INVITE.LANGUAGES' | translate }}</h6>
          <ng-container *ngFor="let testModel of testModels$ | async | filter:'name':'=':'idioma':6">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" [id]="'check' + testModel.id" (click)="toogleTest(testModel)" [checked]="knowledgeTests.includes(testModel)">
              <label class="custom-control-label" [for]="'check' + testModel.id">{{ testModel.name.split('Idioma ')[1] }}</label>
            </div>
            <ng-container *ngIf="testModel.origin === 'ct' && knowledgeTests.includes(testModel)">
              <div class="custom-control custom-checkbox autonotify-checkbox mt-1 ml-3">
                <input class="custom-control-input autonotify-check" type="checkbox" [id]="'autonotify' + testModel.id" (click)="toggleAutonotifyCtReport(testModel, 'toggle')" [checked]="autonotifyCtReports.includes(testModel)">
                <label class="custom-control-label autonotify-label" [for]="'autonotify' + testModel.id">{{'CONSULTANT.SENDREPORTAUTOMATICALLY' | translate}}</label>
              </div>
              <hr class="mt-2 mb-3">
            </ng-container>
          </ng-container>

        </div>

        <div class="col-5">
          <h6>{{ 'INVITE.GENERALS' | translate }}</h6>
          <ng-container *ngFor="let testModel of testModels$ | async | filter:'name':'!':'idioma':6">
            <div class="custom-control custom-checkbox" *ngIf="testModel.id !== 1 && testModel.id !== 2">
              <input class="custom-control-input" type="checkbox" [id]="'check' + testModel.id" (click)="toogleTest(testModel)" [checked]="knowledgeTests.includes(testModel)">
              <label class="custom-control-label" [for]="'check' + testModel.id">{{ testModel.name }}</label>
            </div>

            <div *ngIf="knowledgeTests.includes(testModel) && testModel.origin === 'ct'" class="custom-control custom-checkbox margin-reasoningTest">
              <ng-container *ngFor="let level of filterKnowledgeTestLevels(testModel)">
                <input type="checkbox" [id]="level.description + '_' + level.value" [name]="'test_' + testModel.id + '_level'" [value]="level.value" [checked]="level.checked" (click)="optionsKnowledgeTestLevels($event)">
                <label [for]="level.description + '_' + level.value">{{ 'REPORT.CT.COMMON.AREA.' + level.description | uppercase | translate }}</label>
              </ng-container>

              <div class="row mt-2">
                <div class="col-12">
                  <div class="custom-control custom-checkbox autonotify-checkbox mt-1 ml-3">
                    <input class="custom-control-input autonotify-check" type="checkbox" [id]="'autonotify' + testModel.id" (click)="toggleAutonotifyCtReport(testModel, 'toggle')" [checked]="autonotifyCtReports.includes(testModel)">
                    <label class="custom-control-label autonotify-label" [for]="'autonotify' + testModel.id">{{'CONSULTANT.SENDREPORTAUTOMATICALLY' | translate}}</label>
                  </div>
                  <hr class="mt-2 mb-3">
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div id="testsUploadProgress" class="container my-3" *ngIf="step === 'testsUploadProgress'">
      <div class="card mb-4 border-0 shadow-sm">
        <div class="card-body text-center p-5">
          <ngb-progressbar type="primary" height="20px" [striped]="true" [animated]="true" [value]="uploadProgress()">{{ uploadProgress() | number:'1.0-0' }}%</ngb-progressbar>
          <h4 class="mt-5 mb-3">{{ 'CANDIDATES.ESTIMATEDTIME' | translate }}: {{ estimatedTime() }}</h4>
          <h4>{{ 'COMMON.CANDIDATES' | translate }}: {{ invitationResult.length }}/{{ totalCandidates }}</h4>
        </div>
      </div>
    </div>

    <div id="testsUploadResume" class="container my-3" *ngIf="step === 'testsUploadResume'">
      <div class="card mb-4 border-0 shadow-sm">
        <div class="card-body text-center p-5">
          <div class="resume-icons">
            <i class="fa fa-check-circle fa-5x text-success"></i><span>{{ invitationResult.length }}</span>
            <i class="fa fa-close fa-5x ml-5 text-danger"></i><span>{{ errorEmails.length }}</span>
          </div>
          <div>
            <p *ngIf="errorEmails.length">{{ 'CONSULTANT.SENDTESTFAIL' | translate }}</p>
            <p *ngIf="!errorEmails.length">{{ 'CONSULTANT.SENDTESTSUCCESS' | translate }}</p>
            <ul class="list-group list-group-flush">
              <li class="list-group-item" *ngFor="let email of errorEmails.slice(0, 5)">{{ email }} <i *ngIf="reminderEmails.includes(email)" class="fa fa-bell"></i></li>
            </ul>
            <div *ngIf="errorEmails.length > 5">
              <p>
                <button type="button" class="btn btn-link p-0 box-shadow-none" (click)="collapse.toggle()" [attr.aria-expanded]="!isCollapsed">
                  <ng-container *ngIf="!isCollapsed">{{ 'COMMON.SEELESS' | translate }}</ng-container>
                  <ng-container *ngIf="isCollapsed">{{ 'COMMON.SEEMORE' | translate }}</ng-container>
                </button>
              </p>
              <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item" *ngFor="let email of errorEmails.slice(5)">{{ email }} <i *ngIf="reminderEmails.includes(email)" class="fa fa-bell"></i></li>
                </ul>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-md-6" *ngIf="errorEmails.length">
              <div class="form-group">
                <button type="button" class="btn btn-primary btn-block" (click)="exportErrors(errorEmails)">
                  Exportar pruebas erróneas
                </button>
              </div>
            </div>
            <div [ngClass]="errorEmails.length ? 'col-md-6' : 'col-md-6 offset-md-3'">
              <div class="form-group">
                <button type="button" class="btn btn-primary btn-block" (click)="inviteSent.emit()">
                  {{ 'COMMON.FINALIZE' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-start py-4" *ngIf="step === 'tests'">
    <button type="button" class="btn btn-light" (click)="modal.dismiss('cancel click')" *ngIf="showAsModal">
      {{ 'COMMON.CANCEL' | translate }}
    </button>

    <button type="button" class="btn btn-primary" (click)="invite(false)"
      [ngClass]="{'disabledButton': disableSendButton()}" [disabled]="disableSendButton()">
      {{ 'COMMON.SEND' | translate | titlecase }}
    </button>

    <!-- se muestra para oficinas de hcc y region 70 por req #ESFBITE504 -->
    <button *ngIf="(HCC.includes(officeId)) || regionId === 70" type="button" class="btn btn-primary" (click)="copyInvitationLink()"
     [ngClass]="{'disabledButton': disableSendButton()}" [disabled]="disableSendButton()">
      {{ 'INVITE.ASSIGNANDCOPYLINK' | translate }}
    </button>
  </div>

  <div class="modal-footer justify-content-start py-4" *ngIf="step === 'skill' || step === 'knowledge'">
    <button type="button" class="btn btn-light" (click)="stopAdding('cancel'); jobtypeSelected= null">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="stopAdding('finish'); jobtypeSelected= null">{{ 'COMMON.ADD' | translate }}</button>
  </div>
</ng-template>

<!-- MODAL CONTACTO -->
<ng-template #contactContent let-modal>
  <div class="modal-body" >
    <h6>{{ 'COMMON.PROJECT' | translate }}: {{ projectSelected.name + (projectSelected.description ?  ' - ' + projectSelected.description : '')}}</h6>
    <br/>
    <ng-container *ngFor="let contact of contacts">
      <p>{{ contact.nameComplete }}</p>
      <ul>
        <li *ngIf="contact.detailFunctions">{{ contact.detailFunctions }}</li>
        <li *ngIf="contact.email">{{ contact.email }}</li>
        <li *ngIf="contact.phone1">{{ contact.phone1 }}</li>
      </ul>
    </ng-container>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light center" (click)="modal.close('Close click')">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</ng-template>

<ng-container *ngIf="!showAsModal">
  <ng-container *ngTemplateOutlet="content">

  </ng-container>
</ng-container>
